<template>
  <div>
    <div class="sip_speedometr">
      <img :srcset="`${$server}speedometr.png 1x, ${$server}speedometr_2x.png 2x`" :src="`${$server}speedometr.png`" />
      <img :srcset="`${$server}speedometr_arrow.png 1x, ${$server}speedometr_arrow_2x.png 2x`" :src="`${$server}speedometr_arrow.png`" class="sip_speedometr_arrow" />
      <div class="sip_speedometr_num" v-html="Math.abs(speed)" />
    </div>
    <div class="sip_speedometr_title">{{speedTitle}}</div>
  </div>
</template>
<script>
export default {
  name: 'ControlsSpeedometr',
  props: ['speed'],
  computed: {
    speedTitle() {
      if(this.speed > 0) {
        return 'вперед'
      } else if(this.speed < 0) {
        return 'назад'
      } else if(this.speed === 0) {
        return 'стоп'
      }
    }
  },
}
</script>

<style lang="stylus">
.sip_speedometr
  // border 1px solid
  width 106px
  position relative
  &:after
    content ''
    position absolute
    width 32px
    height 32px
    background #2F7F98
    border 1px solid #FFFFFF
    box-sizing border-box
    box-shadow inset 0px 2px 0px rgba(67, 67, 67, 0.15)
    border-radius 50%
    bottom -10px
    left 50%
    transform translateX(-50%)
    z-index 1
  .sip_speedometr_arrow
    position absolute
    bottom -10px
    left 53px
    transform translateX(-2px) rotate(-50deg)
    transform-origin 1px 55px
    transition transform 0.3s
  .sip_speedometr_num
    position absolute
    bottom 5px
    left 50%
    transform translateX(-50%)
    font-weight bold
    font-size 13px
    color #FFF
    z-index 2
.sip_speedometr_title
  border 1px solid red
  text-align center
  width 100%
  border 1px solid
  background-color #F4A923
  color #FFF
  border 1px solid #FFFFFF
  box-sizing border-box
  box-shadow inset 0px 2px 0px rgba(0, 0, 0, 0.25)
  border-radius 3px
  padding 2px 0 3px 0
  width 102px
  margin -5px auto 0 auto
  position relative
  z-index 2

.page
  .sip_speedometr_num
    bottom 2px

</style>